import { ShaderBase, ShaderUniforms, ShaderAttr } from "./ShaderBase";

export abstract class ShaderManagerBase {
    private shaderMap: Map<string, ShaderBase<ShaderUniforms, ShaderAttr>>;

    constructor(public gl: WebGLRenderingContext) {
        this.shaderMap = new Map<string, ShaderBase<ShaderUniforms, ShaderAttr>>();
    }

    protected getShader(reference: string, settings: string[], factory: () => ShaderBase<ShaderUniforms, ShaderAttr>): ShaderBase<ShaderUniforms, ShaderAttr> {
        let key = this.generateKey(reference, settings);
        if (!this.shaderMap.has(key)) {
            this.shaderMap.set(key, factory());
        }

        return this.shaderMap.get(key);
    }

    private generateKey(reference: string, settings: string[]) {
        return `${reference}:${[...settings].sort().join('/')}`;
    }
}